'use client';

import { useContext, type FC } from 'react';
import styles from './ClientChatThreadAside.module.css';
import type { ClientChatThreadAsideProps } from './ClientChatThreadAside.types';
import { Flex, Heading, Button, ButtonGroup } from '@/_components';
import { useChatScroll } from '@/_hooks/useChatScroll';
import { ClientConversationsContext } from '@/_contexts/client/ClientConversationsProvider';
import { getClasses } from '@/_utils/classnames';

export const ClientChatThreadAside: FC<ClientChatThreadAsideProps> = ({
  children,
  onClose,
}) => {
  const { selectedMessage } = useContext(ClientConversationsContext);
  const onCloseThread = () => onClose();

  const threadsContainer = useChatScroll(selectedMessage);

  const chatThreadAsideClasses: string = getClasses(styles.chatThreadAside);

  return (
    <>
      <Flex className={chatThreadAsideClasses} isColumn={true}>
        <Flex
          className={styles.chatThreadAside__Header}
          isBetween={true}
          isYCentered={true}
        >
          <Flex isYCentered={true} gap={16}>
            <Heading level={4}>Thread</Heading>
          </Flex>
          <ButtonGroup>
            <Button
              onClick={onCloseThread}
              size="small"
              intent="ghost"
              withTooltip={true}
              iconLeft="x"
              isIconOnly={true}
              value="Close Thread"
            />
          </ButtonGroup>
        </Flex>
        <Flex
          isColumn={true}
          padding={6}
          gap={6}
          ref={threadsContainer}
          className={styles.chatThreadAside__Content}
        >
          {children}
        </Flex>
      </Flex>
      <div className={styles.chatThreadAside__off} onClick={onCloseThread} />
    </>
  );
};
